import React from 'react';

function BlissfulGif() {
  return (
    <div className="flex justify-center items-center py-2.5">
      <img 
        src="https://shopblissfulbeauty.com/cdn/shop/files/Blissful.gif?v=1738903316&width=2000" 
        alt="Blissful Beauty Animation" 
        className="max-w-full h-auto"
      />
    </div>
  );
}

export default BlissfulGif;
